import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { getConfig } from "@/lib/config";
import { whatsappLink } from "@/lib/format";

export default function Footer() {
  const [wa, setWa] = useState("966570452861");
  useEffect(() => {
    getConfig().then((c) => setWa(c.whatsapp)).catch(() => {});
  }, []);

  return (
    <footer className="bg-forest text-ivory" data-testid="main-footer">
      <div className="container-lux py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-5">
          <Logo dark />
          <p className="text-ivory/70 text-sm leading-relaxed max-w-sm">
            تجربة لموقع وساطة عقارية متكامل — تصميم فاخر بواجهة عربية لعرض إمكانيات المواقع العقارية الحديثة في السوق السعودي.
          </p>
        </div>
        <div className="md:col-span-3 space-y-4">
          <h4 className="font-heading font-bold text-gold">روابط سريعة</h4>
          <ul className="space-y-2 text-sm text-ivory/80">
            <li><Link className="hover:text-gold transition-colors" to="/properties" data-testid="footer-link-properties">تصفح العقارات</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/projects" data-testid="footer-link-projects">المشاريع السكنية</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/request" data-testid="footer-link-request">اطلب عقارك</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4 space-y-4">
          <h4 className="font-heading font-bold text-gold">تواصل (بيانات عرض)</h4>
          <ul className="space-y-3 text-sm text-ivory/80">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-gold" aria-hidden="true" />
              <a href={whatsappLink(wa, "مرحباً، أرغب بالاستفسار عن عقار (تواصل تجريبي)")} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-testid="footer-whatsapp-link" dir="ltr">
                +966 57 045 2861
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-gold" aria-hidden="true" />
              <span data-testid="footer-email">demo@namothaj-aqari.test</span>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-gold" aria-hidden="true" />
              <span>الرياض — عنوان افتراضي للعرض</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory/10">
        <div className="container-lux py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gold/90 font-heading font-semibold" data-testid="footer-disclaimer">
            إخلاء مسؤولية: هذا الموقع نموذج تجريبي فقط — جميع العقارات والمشاريع والأسعار والبيانات المعروضة افتراضية وليست عروضاً حقيقية، ولا يمثل الموقع نشاطاً تجارياً قائماً.
          </p>
          <p className="text-xs text-ivory/50">نموذج عقاري © 2026</p>
        </div>
      </div>
    </footer>
  );
}
